import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectedProductsArray'
})
export class SelectedProductsArrayPipe implements PipeTransform {
  transform(collection: Array<any>): string {
    if (collection && collection.length) {
      const productPrefix = 'Adding: ';
      return `${productPrefix}${collection
        .map(x => x.name.trim() + `${x.drsValue ? ' (+ ' + (x.drsValue) + ' Deposit)' : ''}`)
        .join(', ')}`;
    }
  }
}
